import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { findAllPerfis } from './api-usuario';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Link } from 'react-router-dom';
import TextFieldCellPhone from '../UI/TextFieldCellPhone';
import { dateTimeFormat } from '../../util/DateUtil';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import UsuarioPhotoForm from './UsuarioPhotoForm';

const useStyles = makeStyles(theme => ({
    paper: {
        // marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    }
}));

const UsuarioForm = ({ usuario, setUsuario, handleSaveUsuario }) => {
    const classes = useStyles();
    const [perfis, setPerfis] = useState([]);

    useEffect(() => {
        findAllPerfis().then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                setPerfis(data);
            }
        });
    }, []);


    const handleChange = (event) => {
        setUsuario({
            ...usuario,
            [event.target.name]: event.target.value ? event.target.value : null
        })
    }

    const handlePerfilChange = (event) => {
        const perfil = perfis.find((perfil) => {
            return perfil === event.target.value;
        });
        setUsuario({
            ...usuario,
            perfil: perfil
        })
    }

    const handleSwitchChange = name => event => {
        setUsuario({ ...usuario, [name]: event.target.checked })
    };



    return (
        <Container component={Paper} maxWidth="sm">
            {!usuario.eNovo ?
                <UsuarioPhotoForm
                    usuario={usuario}
                    setUsuario={setUsuario}
                /> : ''
            }
            <form onSubmit={handleSaveUsuario}>
                <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    size='small'
                    autoFocus
                    label="Nome"
                    name="nome"
                    onChange={handleChange}
                    value={usuario && usuario.nome ? usuario.nome : ''}
                    slotProps={{
                        htmlInput: { maxLength: 255 }
                    }}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    size='small'
                    fullWidth
                    label="Email"
                    name="email"
                    autoComplete="email"
                    onChange={handleChange}
                    value={usuario && usuario.email ? usuario.email : ''}
                    slotProps={{
                        htmlInput: { maxLength: 255 }
                    }}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    size='small'
                    fullWidth
                    label="Cpf/Cnpj - Apenas números"
                    name="cpfCnpj"
                    onChange={handleChange}
                    value={usuario && usuario.cpfCnpj ? usuario.cpfCnpj : ''}
                    slotProps={{
                        htmlInput: { maxLength: 20 }
                    }}
                />
                <FormControl required fullWidth>
                    <InputLabel id="perfil-label">Perfil Ativo</InputLabel>
                    <Select
                        labelId="perfil-label"
                        id="perfil-select"
                        value={usuario && usuario.perfil ? usuario.perfil : ''}
                        onChange={handlePerfilChange}
                    >
                        {perfis.map((perfil, index) => (
                            <MenuItem key={index} value={perfil}>{perfil}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextFieldCellPhone
                    celular={usuario && usuario.celular ? usuario.celular : ''}
                    handleChange={handleChange}
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={usuario && usuario.ativo ? true : false}
                            onChange={handleSwitchChange('ativo')}
                            value={usuario && usuario.ativo ? true : false}
                        />
                    }
                    label="Ativo"
                />
                <p>Data Último Acesso: {usuario.dataUltimoAcesso ? dateTimeFormat(usuario.dataUltimoAcesso) : '--'}</p>
                <div>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}>
                        Salvar
                    </Button>
                </div>
                <div>
                    <Button
                        component={Link}
                        to={{
                            pathname: '/usuario-senha',

                        }}
                        state={{
                            usuario: usuario
                        }}
                        type="button"
                        variant="contained"
                        color="secondary"
                        className={classes.submit}>
                        Trocar Senha
                    </Button>
                </div>
            </form>
        </Container>
    );
}

export default UsuarioForm;